import { render } from "./MoneyTransferModal.vue?vue&type=template&id=c19ad84c&scoped=true&ts=true"
import script from "./MoneyTransferModal.vue?vue&type=script&lang=ts"
export * from "./MoneyTransferModal.vue?vue&type=script&lang=ts"

import "./MoneyTransferModal.vue?vue&type=style&index=0&id=c19ad84c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c19ad84c"]])

export default __exports__